var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var headerShellStyle = {
    background: "transparent",
    width: "100%",
};
export var govBarStyle = {
    alignItems: "center",
    background: "#001A7A",
    borderBottom: "1px solid #0034B7",
    color: "#F8FAFC",
    display: "flex",
    gap: 24,
    justifyContent: "space-between",
    minHeight: 32,
    padding: "2px clamp(16px, 7.8vw, 112px)",
};
export var govIdentityStyle = {
    alignItems: "center",
    display: "flex",
    gap: 8,
    fontSize: 12,
    lineHeight: 1.5,
};
export var govStarImageStyle = {
    display: "block",
    height: 15,
    width: 15,
};
export var accessibilityStyle = {
    alignItems: "center",
    display: "flex",
    gap: 10,
};
export var govBarIconStyle = {
    color: "#F8FAFC",
};
export var fontSizeControlStyle = {
    alignItems: "center",
    background: "#0034B7",
    borderRadius: 100,
    display: "flex",
    gap: 8,
    height: 28,
    padding: "2px 8px",
};
export var accessibilityTextStyle = {
    color: "#F8FAFC",
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1,
};
export var navBarStyle = {
    alignItems: "center",
    background: "transparent",
    borderBottom: "1px solid #CED2D7",
    display: "flex",
    gap: 20,
    justifyContent: "space-between",
    minHeight: 84,
};
export var mobileNavBarOpenStyle = __assign(__assign({}, navBarStyle), { alignItems: "stretch", flexDirection: "column", gap: 0, padding: "0 16px 16px" });
export var mobileNavBarClosedStyle = __assign(__assign({}, navBarStyle), { padding: "0 16px" });
export var mobileTopRowStyle = {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    minHeight: 72,
    width: "100%",
};
export var logoLinkStyle = {
    alignItems: "center",
    display: "flex",
    flex: "1 1 300px",
    minWidth: 220,
    padding: "10px 0",
    textDecoration: "none",
};
export var logoContainerStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    alignItems: "flex-start",
    minWidth: 0,
};
export var logoImageStyle = {
    width: "131.2px",
    height: "auto",
    display: "block",
};
export var logoSubtitleStyle = {
    color: "#0034B7",
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: 0,
    width: "100%",
};
export var mobileMenuButtonStyle = {
    alignItems: "center",
    background: "#FFFFFF",
    border: "none",
    borderRadius: 6,
    color: "#28272C",
    cursor: "pointer",
    display: "flex",
    flex: "0 0 auto",
    height: 40,
    justifyContent: "center",
    padding: 0,
    width: 40,
};
export var navAreaStyle = {
    alignItems: "center",
    display: "flex",
    flex: "0 1 auto",
    flexWrap: "wrap",
    gap: 8,
    justifyContent: "flex-end",
};
export var navLinkBaseStyle = {
    alignItems: "center",
    borderRadius: 2,
    boxSizing: "border-box",
    color: "#28272C",
    display: "flex",
    fontSize: 14,
    lineHeight: 1.5,
    minHeight: 21,
    padding: "0 8px",
    textAlign: "center",
    textDecoration: "none",
};
export var mobileMenuPanelStyle = {
    display: "grid",
    gap: 20,
    paddingTop: 20,
    width: "100%",
};
export var mobileNavAreaStyle = {
    alignItems: "center",
    display: "grid",
    gap: 28,
    justifyItems: "center",
    padding: "0 0 2px",
    width: "100%",
};
export var mobileNavLinkStyle = {
    color: "#000000",
    fontSize: 16,
    lineHeight: 1.5,
    textAlign: "center",
    textDecoration: "none",
};
export var activeNavLinkStyle = __assign(__assign({}, navLinkBaseStyle), { background: "#E6F3FF", boxShadow: "inset 0 0 0 1px #337FFF" });
